import { Dialog } from "quasar";

export default {
   confirm(titleText, messageText) {
      return Dialog.create({
         title  : titleText,
         message: messageText,
         ok     : true,
         cancel : true,
         color  : 'primary'
      })
   }
}
